import { render, staticRenderFns } from "./SubjectHome.vue?vue&type=template&id=717113a4&"
import script from "./SubjectHome.vue?vue&type=script&lang=js&"
export * from "./SubjectHome.vue?vue&type=script&lang=js&"
import style0 from "./SubjectHome.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports